export const getAppName = () => {
    const { hostname } = window.location;
    const splittedHost = hostname.split(".");
    const app = splittedHost[splittedHost.length - 2];

    switch (app) {
        case "nexo":
            return {
                name: app,
                faName: "نکسو"
            };
        default:
            return {
                name: app,
                faName: "پینوست"
            };
    }
};

export const updateAppNames = (class_name) => {
    const elements = document.getElementsByClassName('app_name_container');
    const enElements = document.getElementsByClassName('app_en_name_container');
    const name = getAppName();
    for(let element of elements){
        element.textContent = name.faName;
        element.classList.remove('hidden');
    }
    for(let element of enElements){
        element.textContent = name.name;
        element.classList.remove('hidden');
    }

}
